export default __webpack_public_path__ + "static/media/Kilt of the Amaranthine Drums.ab61482a.jpg";